/* unplugin-vue-components disabled */import { render } from "./CollectUserFace.vue?vue&type=template&id=4d93f8bb&scoped=true"
import script from "./CollectUserFace.vue?vue&type=script&lang=js"
export * from "./CollectUserFace.vue?vue&type=script&lang=js"

import "./CollectUserFace.vue?vue&type=style&index=0&id=4d93f8bb&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d93f8bb"]])

export default __exports__